import { parse as fnsParse } from "date-fns";
import { enUS } from "date-fns/locale";

const DEFAULT_OPTIONS = { locale: enUS };

export function parse(input: string, format: string): Date {
  return fnsParse(input, format, new Date(), DEFAULT_OPTIONS);
}
